import httpClient from "./httpClient";
import { Digest } from "../types/hospitals";

const END_POINT = "/autoemails";

const hospitalCatchmentEmails = async (id: number) => {
	const response = await httpClient.get(`${END_POINT}/hospitalcatchment/${id}`);
	return response.data;
};

const putAutoEmails = async (digest: Digest) => {
	const { id } = digest;
	const response = await httpClient.put(`${END_POINT}/${id || ""}`, digest);
	return response.data as any;
};

const createAutoEmails = async (digest: Digest) => {
	const response = await httpClient.post(`${END_POINT}`, digest);
	return response.data as any;
};

export { hospitalCatchmentEmails, putAutoEmails, createAutoEmails };
